<div class="flex flex-col p-4">
  <ng-container *ngIf="hasMetConsensus; else notMetTemplate">
    <!-- First Section (hasMetConsensus is true) -->
    <div id="consensus_met_section" class="flex justify-between items-center mt-8 border border-solid border-green-500 bg-green-50 pt-2 px-4 rounded-md">
      <span class="flex items-center">
        <span class="mb-2 mr-2">
          67% Rule (Simple Majority)
        </span>
        <div class="relative inline-block">
          <span id="help_icon" class="material-symbols-rounded cursor-pointer" (click)="openModal()">help</span>
          <div id="help_modal" *ngIf="isShowingHelp" class="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-96 p-3 bg-white rounded-lg shadow-lg z-10">
            <div class="flex justify-between items-center">
              <span class="font-semibold text-sm">67% Rule (Simple Majority)</span>
              <button class="text-gray-500 hover:text-gray-700" (click)="closeModal()">
                <span class="material-symbols-rounded">close</span>
              </button>
            </div>
            <hr class="border-t-2 border-black my-1" />
            <span class="text-sm text-gray-700 mt-2">
              67% or more committee members need to vote for the same option to reach a consensus with no major stakeholder objection.
            </span>
            <div class="absolute -top-4 pt-1 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-b-[15px] border-b-white"></div>
          </div>
        </div>
      </span>
      <p class="flex items-center">
        Passed
        <span class="material-symbols-rounded ml-2 text-green-500 cursor-default">check_circle</span>
      </p>
    </div>
  </ng-container>

  <!-- Second Section (hasMetConsensus is false) -->
  <ng-template #notMetTemplate>
    <div id="consensus_not_met_section" class="flex justify-between items-center mt-8 border border-solid border-warningOrange-500 bg-warningOrange-50 pt-2 px-4 rounded-md" id="not_met_bar">
      <span class="flex items-center">
        <span class="mb-2 mr-2">
          67% Rule (Simple Majority)
        </span>
        <div class="relative inline-block">
          <span id="help_icon" class="material-symbols-rounded cursor-pointer" (click)="openModal()">help</span>
          <div id="help_modal" *ngIf="isShowingHelp" class="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-96 p-3 bg-white rounded-lg shadow-lg z-10">
            <div class="flex justify-between items-center">
              <span class="font-semibold text-sm">67% Rule (Simple Majority)</span>
              <button class="text-gray-500 hover:text-gray-700" (click)="closeModal()">
                <span class="material-symbols-rounded">close</span>
              </button>
            </div>
            <hr class="border-t-2 border-black my-1" />
            <span class="text-sm text-gray-700 mt-2">
              67% or more committee members need to vote for the same option to reach a consensus with no major stakeholder objection.
            </span>
            <div class="absolute -top-4 pt-1 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-b-[15px] border-b-white"></div>
          </div>
        </div>
      </span>
      <p class="flex items-center">
        Simple Majority Not Met
        <span class="material-symbols-rounded ml-2 text-warningOrange-500 cursor-default">warning</span>
      </p>
    </div>
  </ng-template>
</div>
